// ===== Services =====

import {
    getAuthErrorMessage,
    getExistingEmailSignInGuidance,
}                                           from '.';

// ===== Interfaces =====

import {
    IEmailConversionErrorMessages,
}                                           from '../interfaces';

// ===== Enums =====

import {
    AUTHENTICATION_ERROR_CODE,
    EMAIL_CONVERSION_CALLABLE_ERROR_CODE,
}                                           from '../enums';

const getEmailConversionErrorMessage = ({
    email,
    error,
    messages,
}: {
    email: string,
    error: {
        code?: string,
        message?: string,
    },
    messages: IEmailConversionErrorMessages,
}): Promise<string> => {
    const code = error.code || '';

    if (code === EMAIL_CONVERSION_CALLABLE_ERROR_CODE.precheckUnavailable) {
        return Promise.resolve(messages.precheckUnavailable);
    }

    if (code.startsWith('functions/')) {
        switch (code) {
        case EMAIL_CONVERSION_CALLABLE_ERROR_CODE.alreadyExists:
            return getExistingEmailSignInGuidance({
                email,
                fallback: messages.emailInUse,
            });
        case EMAIL_CONVERSION_CALLABLE_ERROR_CODE.unavailable:
            return Promise.resolve(messages.precheckUnavailable);
        case EMAIL_CONVERSION_CALLABLE_ERROR_CODE.invalidArgument:
            return Promise.resolve(messages.invalidEmail);
        case EMAIL_CONVERSION_CALLABLE_ERROR_CODE.failedPrecondition:
            return Promise.resolve(messages.notAnonymous);
        case EMAIL_CONVERSION_CALLABLE_ERROR_CODE.notFound:
            return Promise.resolve(messages.userNotFound);
        case EMAIL_CONVERSION_CALLABLE_ERROR_CODE.unauthenticated:
            return Promise.resolve(messages.unauthenticated);
        default:
            return Promise.resolve(messages.fallback);
        }
    }

    if (code.startsWith('auth/')) {
        if (
            code === AUTHENTICATION_ERROR_CODE.emailAlreadyInUse
            || code === AUTHENTICATION_ERROR_CODE.emailAlreadyExists
            || code === AUTHENTICATION_ERROR_CODE.accountExistsWithDifferentCredential
            || code === AUTHENTICATION_ERROR_CODE.credentialAlreadyInUse
        ) {
            return getExistingEmailSignInGuidance({
                email,
                fallback: messages.emailInUse,
            });
        }
        return Promise.resolve(
            getAuthErrorMessage(code as AUTHENTICATION_ERROR_CODE)
            || messages.signInFallback,
        );
    }

    return Promise.resolve(messages.fallback);
};

export default getEmailConversionErrorMessage;
